// ##### 23-12-27 Komarov
import axios from 'axios';
// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
// ##### 25-05-21 Komarov
import EmailNotify from './EmailNotify';
// ##### 25-01-14 Komarov
import { getPostObject } from '../../../helpers/crypto';
// ##### 26-07-30 Komarov
import { smartApiPost } from '../../../helpers/smartApiPost';
// ##### Komarov 2025-05-26
import uniqueId from 'lodash.uniqueid';

// ##### Komarov 2025-07-14
const OnlineSummary = ({ smart_service_id, cart, watchedFormData }) => {
  const [ModifyClientsRQ_Add, setModifyClientsRQ_Add] = useState([]);
  const { user: currentUser } = useSelector(state => state.auth);

  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);
  // ##### 24-03-01 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);
  // ##### 24-08-05 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);
  // ##### Komarov 2025-08-05
  const ThanksReservation = useLocalizedText('ThanksReservation');

  const {
    buyerPrefix,
    buyerFirstName,
    buyerLastName,
    buyerPhone,
    buyerEmail,
    travelersData,
  } = watchedFormData;

  const travelers = travelersData.map(traveler => {
    const {
      site_client_id,
      travelerPrefix,
      travelerFirstName,
      travelerLastName,
      travelerCategory,
    } = traveler;
    return {
      operation: 'add',
      client_type: 'client',
      site_client_id,
      prefix: travelerPrefix,
      name: travelerFirstName,
      surname: travelerLastName,
      category: travelerCategory,
    };
  });

  const travelersCount = travelersData.count;

  // console.log('LOCAL',locale)

  // ##### Komarov 2025-07-12
  useEffect(() => {
    const data = {
      // ##### 25-02-12 Komarov
      company_cipher: company_cipher || '',
      // ##### 23-02-20 Komarov
      service_id: smart_service_id,
      service_number: 1,
      clients: [
        {
          operation: 'add',
          client_type: 'buyer',
          site_client_id: 0,
          prefix: buyerPrefix,
          name: buyerFirstName,
          surname: buyerLastName,
          phone: buyerPhone,
          email: buyerEmail,
        },
        ...travelers,
      ],
    };

    const postObject = getPostObject({
      action: 'ModifyClientsRQ',
      user_id: currentUser.user_id,
      refpartner: company_id,
      language: locale,
      data,
    });

    // ##### 26-07-30 Komarov
    smartApiPost(postObject.url, postObject.parameters).then(response =>
      setModifyClientsRQ_Add(response.data)
    );

    // ##### 24-08-05 Komarov
  }, [
    currentUser.user_id,
    company_id,
    locale,
    smart_service_id,
    travelersCount,
    buyerPrefix,
    buyerFirstName,
    buyerLastName,
    buyerPhone,
    buyerEmail,
    company_cipher,
  ]);

  // console.log('ModifyClientsRQ_Add',ModifyClientsRQ_Add)

  return (
    <>
      {/* <div>Thank your reservation!</div> */}
      <EmailNotify
        smart_service_id={smart_service_id}
        cart={cart}
        watchedFormData={watchedFormData}
      />
      <div data-component="OnlineSummary">
        {
          ModifyClientsRQ_Add.length > 0 &&
          ModifyClientsRQ_Add.map((/* item */) => {
            return (
              <React.Fragment key={uniqueId()}>
                {/* <h4>{item.action}</h4> */}
                {/* ##### 23-10-06 Komarov: TODO: брать перевод из Смарта */}
                <div>{ThanksReservation}</div>
              </React.Fragment>
            );
          })
          //  ):<OfflineSummary  wait={2000}/>
        }
      </div>
    </>
  );
};

export default OnlineSummary;
